import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ConfigurationService } from '@osc-utils/services/configuration.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WebGuard {
  #router = inject(Router);
  #configurationService = inject(ConfigurationService);

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivateBase();
  }

  public canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivateBase();
  }

  private canActivateBase(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.#configurationService.isWebApp() ? true : this.#router.parseUrl('/mobile');
  }
}
